import { render, staticRenderFns } from "./OnlyImagesComponent.vue?vue&type=template&id=745dd964&scoped=true&"
import script from "./OnlyImagesComponent.vue?vue&type=script&lang=js&"
export * from "./OnlyImagesComponent.vue?vue&type=script&lang=js&"
import style0 from "./OnlyImagesComponent.vue?vue&type=style&index=0&id=745dd964&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745dd964",
  null
  
)

component.options.__file = "OnlyImagesComponent.vue"
export default component.exports